import { render, staticRenderFns } from "./WidgetCarouselTextInput.vue?vue&type=template&id=4f6d0795&scoped=true"
import script from "./WidgetCarouselTextInput.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselTextInput.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselTextInput.vue?vue&type=style&index=0&id=4f6d0795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d0795",
  null
  
)

export default component.exports